import * as type from "../types";
import { openSnackbarInfoDispatch, openSnackbarWarning } from './requestAction';
import { deleteReq, get, patch, post } from './../../config/Requests';
import { setData } from './../helpers';
import moment from "moment-timezone";
import t from "../../languages/pl";
import {
  usersCarsListRoute,
  usersListRoute,
  usersPasswordExpirationRoute,
  usersPasswordResetRoute
} from './../../config/routes';

export const getUsers = () => {

  return dispatch => {

    get(
      dispatch,
      usersListRoute,
      {},
      response => {
        setData(dispatch, type.SET_USERS_LIST, response);
      }
    );
  };
};


export const addUser = data => {
  return (dispatch) => {
    post(
      dispatch,
      usersListRoute,
      data,
      response => {
        let newUser = {
          uzytkownik_id: response.data.uzytkownik_id,
          liczba_aut: data.auto_id.length,
          ost_aktywnosc: moment().unix(),
          ...data
        };
        dispatch({
          type: type.ADD_USER,
          value: newUser
        });
      },
      error => {
        if (!!error && error.status === 400)
          openSnackbarWarning(dispatch, `Błąd serwera. Kod ${error.status}`);
      }
    );
  };
};

export const editUser = (id, data) => {
  return dispatch => {
    patch(
      dispatch,
      usersListRoute,
      { uzytkownik_id: id },
      data,
      () => {
        dispatch({
          type: type.UPDATE_USER,
          id: id,
          value: data
        });
      }
    );
  };
};

export const deleteUser = userId => {
  return dispatch => {
    deleteReq(
      dispatch,
      usersListRoute,
      { uzytkownik_id: userId },
      () => {
        dispatch({
          type: type.DELETE_USER,
          value: userId
        });
        openSnackbarInfoDispatch(dispatch, t.userDeleted);
      }
    );
  };
};

export const getUserCars = id => {
  return dispatch => {
    get(
      dispatch,
      usersCarsListRoute,
      { uzytkownik_id: id },
      response => {
        setData(dispatch, type.SET_USER_CARS, response);
      }
    );
  };
};

export const editUserCars = (id, carIds) => {
  return (dispatch, getState) => {
    let allCars = getState().carsReducer.cars;
    let cars = allCars.filter(car => carIds.includes(car.auto_id));
    const allUsers = getState().userReducer.users;
    let user = allUsers.find(user => user.uzytkownik_id === id);
    patch(
      dispatch,
      usersCarsListRoute,
      { uzytkownik_id: id },
      { auto_id: carIds },
      () => {
        user.liczba_aut = cars.length;
        dispatch({
          type: type.UPDATE_USER,
          id: id,
          value: user
        });
        dispatch({
          type: type.SET_USER_CARS,
          value: cars
        });
      }
    );
  };
};

export const resetUserPassword = id => {
  return dispatch => {
    get(
      dispatch,
      usersPasswordResetRoute,
      { uzytkownik_id: id },
      () => {
        openSnackbarInfoDispatch(dispatch, t.passwordHasBeenReseted);
      }
    );
  };
};

export const changePasswordExpiration = (id, value) => {
  return dispatch => {
    patch(
      dispatch,
      usersPasswordExpirationRoute,
      { uzytkownik_id: id },
      { waznosc_hasla: value },
      () => {
        openSnackbarInfoDispatch(dispatch, t.passwordExpirationDateHasBeenChanged);
      }
    );
  };
};
